import ErrorPage from "client/common/components/errors/ErrorPage";
import { useClinic } from "client/clinics/hooks";
import { urls } from "client/routes";

const InvalidLinkPage = () => {
  const clinic = useClinic();

  return (
    <ErrorPage
      title="This link is not valid"
      description={`This may have happened because the link no longer works or the URL is incorrect. Please try to login below or reach out to ${clinic.display_name} for a new link.`}
      buttonText="Login"
      buttonLink={urls.accounts.login.to()}
    />
  );
};

export default InvalidLinkPage;
